export default "__VITE_ASSET__hhLn1oKW__"